import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/form.module'



export default function ForumBasicInfoComponent({ handleBasicFormChange, forumGroups, selectedForum }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

            <InputContainer
              label="Forum Group"
              labelField="Name"
              list={forumGroups}
              onValueChange={(event: any, newValue: any) => {
                handleBasicFormChange({
                  value: event.target.value,
                  field: 'Forum.ForumGroupId',
                  data: selectedForum?.Forum
                });
              }}
              optionName="Choose Forum Group"
              type="select"
              value={selectedForum?.Forum?.ForumGroupId}
              valueField="Id"
            />
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedForum?.Name}
            />

            <InputContainer
              label="Description"
              name="Description"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'Description',
                )
              }}
              type="text"
              value={selectedForum?.Description}
            />

            <InputContainer
              label="DisplayOrder"
              name="DisplayOrder"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'DisplayOrder',
                )
              }}
              type="number"
              value={selectedForum?.DisplayOrder}
            />

          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />


    </>
  )
}